import React, { useState,useEffect } from 'react';
import './login.css';  // The CSS file containing the above styles
import News from './Left';
import Log from './Right'; // This is your login component
import ForgotPassword from './Forgotpass'; // Import the new ForgotPassword component

const Login = () => {
  const [isForgotPassword, setIsForgotPassword] = useState(false); // State to toggle between Login and Forgot Password
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

  const handleForgotPasswordClick = () => {
    setIsForgotPassword(true); // Switch to Forgot Password
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Check if screen is mobile size
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div className="app-container" style={{ padding: '0px' }}>
      <div className="left-section" style={{ display: isMobile ? 'none' : 'block' }}>
        <div className="background-overlay">
          <News />
        </div>
      </div>
      <div className="right-section">
        {/* Conditionally render the Log or ForgotPassword component */}
        {isForgotPassword ? (
          <ForgotPassword />
        ) : (
          <Log onForgotPasswordClick={handleForgotPasswordClick} />
        )}
      </div>
    </div>
  );
};

export default Login;
